import { render, staticRenderFns } from "./SetNewPasswordPage.vue?vue&type=template&id=47cb48e4&scoped=true&"
import script from "./SetNewPasswordPage.vue?vue&type=script&lang=js&"
export * from "./SetNewPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./SetNewPasswordPage.vue?vue&type=style&index=0&id=47cb48e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cb48e4",
  null
  
)

export default component.exports